<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <div id="workflow-process_execution" class="content">
                <em-workflow-process-execution :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey" :businessKey="$_emWorkflowTaskMixin_businessKey">
                </em-workflow-process-execution>
            </div>

            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <em-Spp-Workflow-TaskComplete :businessKey="$_emWorkflowTaskMixin_businessKey"
                                              :taskId="$_emWorkflowTaskMixin_taskId"
                                              :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                           @taskCompleted="$_emWorkflowTaskMixin_handleTaskCompleted">
                    <!--自定义插槽示例,异常转维修工单-->
                    <!--<template slot="customSlot" slot-scope="slotScopeToRepairWorkOrder">-->
                    <!--        <em-button type="add"-->
                    <!--                    v-bind:class="'btn btn-primary'"-->
                    <!--                    showName-->
                    <!--                    v-menu-permission="'edit'"-->
                    <!--                    customLabel = "title.em.epi.todo.abnormal.toAbnormal"-->
                    <!--                    @click="handleToRepairWorkOrder">-->
                    <!--        </em-button>-->
                    <!--</template>-->
                </em-Spp-Workflow-TaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
    // Author thq
    // Date 2021-07-06 16:54:47

    import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
    import emSppWorkflowTaskComplete from "@/components/em/EmWorkflow/SppTaskComplete";

    export default {
        name: "emSppRequisitionSprWorkflowTaskView",
        mixins: [emWorkflowTaskMixin],
        components:{
          emSppWorkflowTaskComplete
        },
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            }
        }
    };
</script>